// extracted by mini-css-extract-plugin
module.exports = {"container":"GoogleConnectItem_container__3AzEd","center":"GoogleConnectItem_center__R5Xgf","body":"GoogleConnectItem_body__O3WuF"};